import {
  Box,
  Select,
  Typography,
  InputAdornment,
  InputLabel,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import { TransTextInput } from "./TransTextInput";

export const TransSelect = ({
  label,
  placeholder,
  value,
  defaultValue,
  onChange,
  inputAdornments,
  width,
  options,
  name,
  errors,
  validation,
  wrapperSx,
  isDisabled,
  mode,
  formData,
  filterBasedOnField,
  optionLabelKey,
}) => {
  const [selectOptions, setSelectOptions] = useState([]);

  const onSelectChange = (e) => {
    return onChange(name, e.target.value);
  };

  const getOptions = useCallback(() => {
    if (
      _.isEmpty(filterBasedOnField) ||
      _.isEmpty(formData) ||
      !formData[filterBasedOnField]
    ) {
      return options;
    }

    return options.filter(
      (option) => option[filterBasedOnField] === formData[filterBasedOnField]
    );
  }, [filterBasedOnField, formData, options]);

  useEffect(() => {
    const newOptions = getOptions();
    setSelectOptions(newOptions);
  }, [getOptions]);

  return (
    <Box sx={wrapperSx}>
      <Typography
        htmlFor={name}
        component={InputLabel}
        fontWeight={500}
        fontSize={14}
        color="#000"
        error={errors?.status}
        required={validation?.required}
      >
        {label}
      </Typography>

      <Select
        variant="outlined"
        placeholder={placeholder}
        disabled={isDisabled}
        value={value}
        defaultValue={defaultValue || ""}
        onChange={onSelectChange}
        sx={{
          width: width || "auto",
          pointerEvents: isDisabled || mode === "view" ? "none" : "all",
        }}
        inputProps={{
          sx: { border: "none" },
          readOnly: isDisabled || mode === "view",
          type: "search",
        }}
        error={errors?.status}
        helperText={errors?.status && _.capitalize(errors?.message)}
      >
        {selectOptions.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {_.startCase(option[optionLabelKey || "name"])}
          </MenuItem>
        ))}
      </Select>
      {errors?.status && (
        <FormHelperText error={errors.status}>
          {_.capitalize(errors?.message)}
        </FormHelperText>
      )}
    </Box>
  );
};
